import { FlexContainer, Text } from '../../../../../../../../../ui/index.ts';
import { usePhotosController } from './controller/index.ts';

export function Photos() {
  const { tagText } = usePhotosController();

  return (
    <FlexContainer alignItems="center" justifyContent="center">
      <Text
        text={tagText}
        size={22}
        family="secondary"
        uppercase
        weight="Bold"
        align="center"
        color="black-primary"
      />
    </FlexContainer>
  );
}
